// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__3JRXF","title":"Select_title__2d_0I","label":"Select_label__1PJGo"};